const Personal = ({ color = "var(primary100)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5073 11.5933C16.5073 14.5612 14.0929 16.9757 11.1249 16.9757C8.15692 16.9757 5.74248 14.5612 5.74248 11.5933C5.74248 11.1472 6.1041 10.7856 6.55017 10.7856C6.99624 10.7856 7.35785 11.1472 7.35785 11.5933C7.35785 13.6706 9.04753 15.3603 11.1249 15.3603C13.2023 15.3603 14.8919 13.6706 14.8919 11.5933C14.8919 11.1472 15.2535 10.7856 15.6996 10.7856C16.1457 10.7856 16.5073 11.1472 16.5073 11.5933ZM11.1249 0.5C5.33541 0.5 0.625 5.21041 0.625 10.9999C0.625 16.7894 5.33541 21.4998 11.1249 21.4998C16.9144 21.4998 21.6248 16.7894 21.6248 10.9999C21.6248 5.21041 16.9144 0.5 11.1249 0.5Z"
        fill={color}
      />
    </svg>
  );
};

export default Personal;
